// @ts-nocheck
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const userStore = useUserStore()
  const { $bus, $gtm } = useNuxtApp()

  if (useRuntimeConfig().public.stage !== 'live') {
    $gtm.push({ develop_mode: true })
  }

  router.afterEach(to => {
    $gtm.push(
      to.gtm || {
        routeName: to.name,
        pageType: 'PageView',
        pageUrl: `${window.location.protocol}//${window.location.host}${to.fullPath}`,
        pageTitle: (typeof document !== 'undefined' && document.title) || '',
        event: 'nuxtRoute'
      }
    )
  })

  $bus.$on(
    'view-details',
    ({ sourceComponent, product, sourceUrl, eventId }) => {
      if (!product) { return }
      $gtm.push({
        event: 'viewDetails',
        ecommerce: {
          detail: {
            actionField: {
              list: sourceComponent
            },
            products: [
              {
                name: `${product.title} ${product.colorName}`.toLowerCase(),
                category: product.category,
                variant: product.colorName.toLowerCase(),
                price: product.price.replace(',', '.'),
                id: `CID${product.cId}`
              }
            ]
          }
        },
        pageUrl: sourceUrl,
        google_tag_params: {
          ecomm_prodid: `CID${product.cId}`,
          ecomm_pagetype: 'product',
          ecomm_totalvalue: product.price.replace(',', '.')
        },
        fb_content_ids: product.cId, // cId
        fb_value: product.price.replace(',', '.'),
        fb_event_id: eventId,
        external_id: userStore.uniqueId
          ? userStore.uniqueId
          : null
      })
    }
  )
  $bus.$on('add-to-cart', ({ eventId, product, size }) => {
    $gtm.push({
      event: 'addToCart',
      ecommerce: {
        currencyCode: 'EUR',
        add: {
          products: [
            {
              id: size.pId,
              name: `${product.title} ${product.colorName}`?.toLowerCase(),
              price: product.price.replace(',', '.'),
              category: product.category,
              variant: product.colorName,
              size: size?.size?.toLowerCase(),
              position: 0,
              quantity: 1
            }
          ]
        }
      },
      google_tag_params: {
        ecomm_prodid: size.pId,
        ecomm_pagetype: 'addToCart',
        ecomm_totalvalue: product.price.replace(',', '.')
      },
      fb_content_ids: size.pId,
      fb_value: product.price.replace(',', '.'),
      fb_event_id: eventId,
      external_id: userStore.uniqueId ? userStore.uniqueId : null
    })
  })
  $bus.$on('add-to-wishlist', ({ eventId, product }) => {
    $gtm.push({
      event: 'addToWishlist',
      ecommerce: {
        currencyCode: 'EUR',
        add: {
          products: [
            {
              id: `CID${product.cId}`,
              name: `${product.title} ${product.colorName}`.toLowerCase(),
              price: product.price.replace(',', '.'),
              category: product.category,
              variant: product.colorName,
              position: 0,
              quantity: 1
            }
          ]
        }
      },
      fb_content_ids: product.cId,
      fb_value: product.price.replace(',', '.'),
      fb_event_id: eventId,
      external_id: userStore.uniqueId ? userStore.uniqueId : null
    })
  })
  // Not being used right now
  // $bus.$on('remove-from-wishlist', ({ eventId, product }) => {
  //   $gtm.push({
  //     event: 'removeFromWishlist',
  //     ecommerce: {
  //       currencyCode: 'EUR',
  //       remove: {
  //         products: [
  //           {
  //             id: `CID${product.cId}`,
  //             name: `${product.title} ${product.colorName}`.toLowerCase(),
  //             price: product.price.replace(',', '.'),
  //             category: product.category,
  //             variant: product.colorName,
  //             position: 0,
  //             quantity: 1
  //           }
  //         ]
  //       }
  //     },
  //     fb_content_ids: product.cId,
  //     fb_value: product.price.replace(',', '.'),
  //     fb_event_id: eventId,
  //     external_id: userStore.uniqueId ? userStore.uniqueId : null
  //   })
  // })
  $bus.$on('add-search-query', ({ amount, products, path, query }) => {
    const cIds = products.map(product => {
      return `${product.cId}`
    })
    $gtm.push({
      event: 'addSearchQuery',
      result: amount > 0 ? 'result' : 'noresult',
      page: path,
      query,
      fb_content_ids: cIds,
      external_id: userStore.uniqueId ? userStore.uniqueId : null
    })
  })
  $bus.$on('product-click', ({ product, sourceComponent, category }) => {
    $gtm.push({
      event: 'productClick',
      ecommerce: {
        click: {
          actionField: { list: sourceComponent },
          products: [
            {
              name: product.title,
              id: `CID${product.cId}`,
              price: product.price,
              category: category ? category.slug : null
            }
          ]
        }
      },
      external_id: userStore.uniqueId ? userStore.uniqueId : null
    })
  })
  $bus.$on('set-cookies', data => {
    $gtm.push(data)
  })
  $bus.$on(
    'checkout-progress',
    ({
      eventId,
      sourceUrl,
      pIds,
      step,
      products,
      cartTotal,
      shippingMethod,
      paymentMethod,
      coupons
    }) => {
      $gtm.push({
        event: 'checkoutProgress',
        ecommerce: {
          checkout: {
            actionField: {
              step,
              option: step === 4 ? shippingMethod : (step === 5 ? paymentMethod : null)
            },
            products,
            coupons: coupons.length ? coupons.join(',') : null
          }
        },
        google_tag_params: {
          ecomm_prodid: pIds,
          ecomm_pagetype: 'cart',
          ecomm_totalvalue: cartTotal
        },
        fb_event_id: eventId,
        fb_value: cartTotal,
        external_id: userStore.uniqueId
          ? userStore.uniqueId
          : null
      })
    }
  )
  $bus.$on('complete-registration', ({ eventId }) => {
    $gtm.push({
      event: 'completeRegistration',
      fb_event_id: eventId,
      external_id: userStore.uniqueId ? userStore.uniqueId : null
    })
  })
  $bus.$on(
    'purchase',
    ({
      invoiceId,
      total,
      taxTotal,
      shippingCosts,
      coupons,
      pIds,
      products,
      email,
      externalId
    }) => {
      $gtm.push({
        event: 'purchase',
        ecommerce: {
          purchase: {
            actionField: {
              id: invoiceId,
              affiliation: 'googleAnalytics',
              revenue: total,
              tax: taxTotal, // Tax total
              shipping: shippingCosts,
              coupon: coupons
            },
            products
          }
        },
        google_tag_params: {
          ecomm_prodid: pIds, // pId array
          ecomm_pagetype: 'purchase',
          ecomm_totalvalue: total // Order total
        },
        fb_content_ids: pIds, // pId array
        fb_value: total, // Order value
        fb_prodcount: pIds.length, // Aantal producten
        fb_event_id: invoiceId, // for purchase event: fb_event_id = invoiceId
        external_id: externalId,
        email
      })
    }
  )
  $bus.$on('event-contact', ({ action, label }) => {
    $gtm.push({
      event: 'eventContact',
      action,
      label,
      external_id: userStore.uniqueId ? userStore.uniqueId : null
    })
  })
  $bus.$on('user-id', ({ userId }) => {
    $gtm.push({
      user_id: userId,
      external_id: userStore.uniqueId ? userStore.uniqueId : null
    })
  })
  $bus.$on('remove-from-cart', ({ product, size }) => {
    $gtm.push({
      event: 'removeFromCart',
      ecommerce: {
        currencyCode: 'EUR',
        remove: {
          products: [
            {
              id: size.pId,
              name: `${product.title} ${product.colorName}`.toLowerCase(),
              price: product.price.replace(',', '.'),
              category: product.category,
              variant: product.colorName,
              size: size.size.toLowerCase(),
              position: 0,
              quantity: 1
            }
          ]
        }
      }
    })
  })
  $bus.$on(
    'add-impressions',
    ({ eventId, products, sourceUrl, category }) => {
      const impressions = products.map(product => {
        return {
          name: `${product.title} ${product.colorName}`.toLowerCase(),
          id: `CID${product.cId}`
        }
      })

      const prodIds = products.map(product => {
        return `CID${product.cId}`
      })

      const cIds = products.map(product => {
        return `${product.cId}`
      })
      $gtm.push({
        event: 'addImpressions',
        ecommerce: {
          impressions
        },
        pageUrl: sourceUrl,
        google_tag_params: {
          ecomm_prodid: prodIds,
          ecomm_pagetype: 'category',
          ecomm_category: category.id
        },
        fb_content_ids: cIds,
        fb_event_id: eventId,
        external_id: userStore.uniqueId
          ? userStore.uniqueId
          : null
      })
    }
  )
  $bus.$on('view-store-stock', () => {
    $gtm.push({
      event: 'viewStoreStock',
      external_id: userStore.uniqueId ? userStore.uniqueId : null
    })
  })
})
